export class SeprateThreeD {
   static SeparatorOfThreeDigits(number) {
      const numberArray = [];
      if (number.length >= 3) {
         let newNumber = number.replaceAll(',', '');
         for (let i = newNumber.length; i > 0; i -= 3) {
            numberArray.push(newNumber.substring(i, i - 3));
         }
         let mainNm = numberArray.reverse().join(',');
         return mainNm;
      } else {
         return number;
      }
   }
}

/*if delete a comma and leftOver 6 or 5 or 4 Number
 A previous number will be deleted ⤵ 
 */
export class HandleCommaDeleted {
   static deleteComma(number) {
      let numberArray = number.split(',');
      let inxOfSix = numberArray.findIndex((el) => el.length === 6);
      let inxOfFive = numberArray.findIndex((el) => el.length === 5);
      let inxOfFour = numberArray.findIndex((el) => el.length === 4);
      if (inxOfSix !== -1) {
         numberArray[inxOfSix] =
            numberArray[inxOfSix].slice(0, 2) + numberArray[inxOfSix].slice(3, 6);
         return String(numberArray);
      } else if (inxOfFive !== -1) {
         numberArray[inxOfFive] =
            numberArray[inxOfFive].slice(0, 1) + numberArray[inxOfFive].slice(2, 5);
         return String(numberArray);
      } else if (inxOfFour !== -1) {
         numberArray[inxOfFour] =
            numberArray[inxOfFour].slice(0, 0) + numberArray[inxOfFour].slice(1, 4);
         return String(numberArray);
      } else {
         return number;
      }
   }
}
